import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/diaspora': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M251.6 354.5c-1.4 0-88 119.9-88.7 119.9-0.7 0-86.6-60.5-86.9-61.2s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-0.5 31.4-101.8 31.7-102.1 0.6-0.7 144.4 47 145.5 47 0.4 0 0.9-0.6 1-1.3 0.4-2 1-148.6 1.7-149.6 0.8-1.2 104.5-0.7 105.1-0.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3 0.8 0.9 31.9 102.2 31.5 102.6-0.9 0.9-140.2 47.1-140.6 48.8-0.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-0.2-89-125.5-90.9-125.5h0z'
      }
    ]
  }
})
